import { Text } from '@spotify-internal/encore-web';

import { formatToolResultContent } from './parseToolResult';

import styles from './ToolResponseDetails.module.css';

export const ToolTextDetails = ({ content }: { content: string }) => (
  <div className={styles.detailsBox}>
    <Text as="pre" variant="bodySmallMono" className={styles.content}>
      {content}
    </Text>
  </div>
);

export const ToolResponseDetails = ({ content }: { content: string }) => (
  <ToolTextDetails content={formatToolResultContent(content)} />
);
